import { Button } from "@heroui/react";

export default function FallbackLoader({ router }) {
    return (
        <div className="min-h-screen bg-gradient-to-t from-blue-100 to-white flex flex-col items-center justify-center px-4 py-12">
            <div className="max-w-md w-full bg-white rounded-xl shadow-lg overflow-hidden">
                <div className="p-8">
                    <div className="flex justify-center mb-6">
                        <div className="relative">
                            <div className="h-24 w-24 rounded-full border-t-4 border-b-4 border-indigo-500 animate-spin"></div>
                            <div className="absolute inset-0 flex items-center justify-center">
                                <svg className="h-12 w-12 text-indigo-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                                </svg>
                            </div>
                        </div>
                    </div>

                    <h2 className="text-center text-2xl font-baskervil font-bold text-gray-800 mb-4">
                        Ups, ta strona została dodana w ciągu ostatnich 60 sekund, pracujemy nad nią.
                    </h2>

                    <p className="text-center text-gray-600 mb-6">
                        Poczekaj jeszcze chwilkę.
                    </p>

                    <div className="w-full bg-gray-200 rounded-full h-2 mb-6">
                        <div className="bg-indigo-600 h-2 rounded-full animate-pulse"></div>
                    </div>

                    <div className="flex justify-center">
                        <Button
                            color="primary"
                            variant="flat"
                            onPress={() => router.reload()}
                            className="font-medium"
                        >
                            Odśwież stronę
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
